import React, { useRef } from 'react';
import './FormContainer.scss';
import './FormContainer-media.scss';
import Button from '../Button/Button';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { EnumUrlsPages } from '../../services/Enum';
import { LinkTg, LinkWhatsapp } from '../../services/content/Constants';
import { Props } from './interfaces';
import { CSSTransition } from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import { AdaptiveValue } from '../../services/GlobalFunctions';
import {content} from "../../services/content";

const FormContainer = ({
  title = 'Остались вопросы?',
  subTitle = 'Dalli всегда рядом',
  buttonText = 'Отправить',
  buttonWidthAll = false,
  buttonType = 'black',
  form,
  onSubmit,
  serverText,
  successShow,
  whatsapp = false,
  telegram = false,
  phone = false,
  heightSuccessForm = '444px',
  image,
  imageText,
  widthRight,
  disableBtn,
  showBlockedError,
  widthWindow,
}: Props) => {
  const TitleBlock = (
    <div className="form-container__block-title">
      <h2 className="form-container__title">{title}</h2>
      {subTitle ? <p className="body1 form-container__sub-title">{subTitle}</p> : null}
    </div>
  );

  const widthR = widthRight ? AdaptiveValue({ widthWindow, value: widthRight }) : 'auto';

  const heightSuccess = AdaptiveValue({ widthWindow, value: heightSuccessForm });

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <>
      <div
        className={`form-container ${successShow ? 'form-container_success' : ''}`}
        style={successShow ? { height: heightSuccess } : {}}
      >
        <CSSTransition
          in={successShow}
          nodeRef={nodeRefSuccess}
          timeout={{ appear: 200, enter: 0, exit: 200 }}
          classNames="css-transition-modal"
          unmountOnExit
        >
          <SuccessContent refCss={nodeRefSuccess} />
        </CSSTransition>

        <CSSTransition
          in={!successShow}
          nodeRef={nodeRef}
          timeout={{ appear: 200, enter: 0, exit: 0 }}
          classNames="css-transition-content"
          unmountOnExit
        >
          <div
            className="form-container__block"
            style={widthRight ? { gridTemplateColumns: `auto ${widthR}` } : {}}
          >
            <div className="form-container__block-header">
              {image ? (
                <>
                  <img src={image} className="form-container__image" alt="form" />
                  {imageText ? (
                    <div
                      className="form-container__image-text"
                      dangerouslySetInnerHTML={{ __html: imageText }}
                    ></div>
                  ) : null}
                </>
              ) : (
                TitleBlock
              )}

              <div className="form-container__contacts">
                {whatsapp ? (
                  <a href={LinkWhatsapp} rel="nofollow">
                    <img src={require('./img/whatsapp.svg').default} className="form-container__soc" alt="" />
                  </a>
                ) : null}
                {telegram ? (
                  <a href={LinkTg} target="_blank" rel="nofollow">
                    <img src={require('./img/tg.svg').default} className="form-container__soc" alt="" />
                  </a>
                ) : null}
                {phone ? (
                  <a href={`tel:${content.formContainer.phoneNumber}`}>
                    <h4>{content.formContainer.phoneNumber}</h4>
                  </a>
                ) : null}
              </div>
            </div>

            <form className="form-container__form" onSubmit={onSubmit}>
              {image && (title.length || subTitle.length) ? TitleBlock : null}
              {form}

              <div className="form-container__button">
                {serverText ? ErrorText(serverText) : null}
                <Button
                  text={buttonText}
                  widthAll={buttonWidthAll}
                  type={buttonType}
                  disabled={disableBtn}
                  showBlockedError={showBlockedError}
                />
              </div>
              <p className="form-container__agreement">
                {content.formContacts.text1}
                <a href={EnumUrlsPages.policy}>{content.formContacts.privacyPolicy}</a>
                {content.formContacts.text2}
              </p>
            </form>
          </div>
        </CSSTransition>
      </div>
      <div className="form-container__bg"></div>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormContainer));
